import React, { useState } from "react";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import Controls from "../../../controls/Controls";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

const CompanyCredit = ({ AddCreditPayment, countries, companyId }) => {
  const [interest, setInterest] = React.useState("");
  const [isCredit, setIsCredit] = React.useState(false);
  const [period, setPeriod] = React.useState("");
  const [chargeInterest, setChargeInterest] = React.useState(false);
  const [lateInterestPayment, setLateInterestPayment] = React.useState(false);

  const interestChange = (event) => {
    setInterest(event.target.value);
  };

  const isCreditChange = (event) => {
    setIsCredit(event.target.value);
  };

  const isChargeInterestChange = (event) => {
    setChargeInterest(event.target.value);
  };

  const isLatePayment = (event) => {
    setLateInterestPayment(event.target.value);
  };

  const periodChange = (event) => {
    setPeriod(event.target.value);
  };

  const history = useHistory();
  const submit = () => {
    const payload = {
      companyId: companyId,
      isCredit: isCredit,
      chargeInterest: chargeInterest,
      interest: interest,
      periodId: period,
      maxPeriod: 0,
    };
    console.log("here is your submit payload ===", payload);
    AddCreditPayment(payload);
    history.push("./user/login");
  };

  //  style={{ backgroundColor: "#E9EDFF" }}
  return (
    <>
      <div className="h-screen bg-[#E9EDFF] p-0 m-0">
        <div className="container-fluid w-100 m-0 p-3 text-center">
          <h1 className="font-semibold">Company Credit Setup</h1>
        </div>
        <div className="container w-50 mt-4">
          <Box className="pb-3" sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Do you sell on Credit?
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={isCredit}
                name="isCredit"
                label="credit"
                onChange={isCreditChange}
              >
                <MenuItem value={true}>Yes</MenuItem>
                <MenuItem value={false}>No</MenuItem>
              </Select>
            </FormControl>
          </Box>

          {isCredit === true ? (
            <>
              <Box className="pb-3" sx={{ minWidth: 120 }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    If Yes, Do you Charge Interest?
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="interest"
                    value={chargeInterest}
                    label="interest"
                    onChange={isChargeInterestChange}
                  >
                    <MenuItem value={true}>Yes</MenuItem>
                    <MenuItem value={false}>No</MenuItem>
                  </Select>
                </FormControl>
              </Box>
              <Box className="pb-3" sx={{ minWidth: 120 }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Do you charge interest on Late Payment
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="interest"
                    value={lateInterestPayment}
                    label="interest"
                    onChange={isLatePayment}
                  >
                    <MenuItem value={true}>Yes</MenuItem>
                    <MenuItem value={false}>No</MenuItem>
                  </Select>
                </FormControl>
              </Box>
              {(chargeInterest || lateInterestPayment) && (
                <div className="row">
                  <div className="col">
                    <Controls.Input
                      label="Interest"
                      type="number"
                      name="credit"
                      value={interest}
                      onChange={interestChange}
                    />
                  </div>
                  <div className="col">
                    <Box sx={{ minWidth: 120 }}>
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          Period
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={period}
                          label="Age"
                          name="period"
                          onChange={periodChange}
                        >
                          <MenuItem value={0}>None</MenuItem>
                          <MenuItem value={1}>Daily</MenuItem>
                          <MenuItem value={2}>Weekly</MenuItem>
                          <MenuItem value={3}>Monthly</MenuItem>
                          <MenuItem value={4}>Quarterly</MenuItem>
                          <MenuItem value={5}>Yearly</MenuItem>
                        </Select>
                      </FormControl>
                    </Box>
                  </div>
                </div>
              )}
              <Button
                onClick={submit}
                style={{
                  width: "10rem",
                  backgroundColor: "#303f9f",
                  color: "#fff",
                  marginTop: "1rem",
                }}
              >
                Submit
              </Button>
            </>
          ) : (
            <Link to="/user/Login">
              <Button
                style={{
                  width: "10rem",
                  backgroundColor: "#303f9f",
                  color: "#fff",
                  marginTop: "1rem",
                }}
              >
                Continue to Login
              </Button>
            </Link>
          )}

          {/* End Condition Here */}
        </div>
      </div>
    </>
  );
};

function mapStateToProps(state) {
  return {
    buttonloader: state.utilityReducer.buttonloader,
    payments: state.salesReducer.payments,
    repayments: state.salesReducer.repayments,
    accountTypes: state.salesReducer.accountTypes,
    companyId: state.persistReducer.companyId,
    accounts: state.salesReducer.accounts,
    paymentTypes: state.salesReducer.paymentTypes,
    cardTypes: state.salesReducer.cardTypes,
    countries: state.persistReducer.countries,
  };
}
const mapDispatchToProps = (dispatch) => ({
  AddCreditPayment(payload) {
    dispatch({ type: "COMPANY_CREDIT", payload });
  },

  LoadRePayments(payload) {
    dispatch({ type: "LOAD_REPAYMENT", payload: payload });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CompanyCredit);
